import { render, staticRenderFns } from "./MonumentCard.vue?vue&type=template&id=58dc39f1&"
import script from "./MonumentCard.vue?vue&type=script&lang=js&"
export * from "./MonumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports